module.exports = __webpack_public_path__ + "img/Group4.74a85d55.png";